/**
 * Clears the URL proxy's access_token cookie by calling the /auth/logout endpoint.
 * This is a cross-origin fetch with credentials so the browser sends (and clears)
 * the proxy's cookie. Fire-and-forget — failures are logged but never block the caller.
 */
export const clearProxyAuth = async (): Promise<void> => {
  const env = process.env.GATSBY_ENV;
  // Skip in local dev — there is no tyrell-proxy running locally
  if (!env || env === 'local') return;

  // Proxy always includes the deployment ID (e.g. tyrell-proxy.prod.rendered.ai)
  const proxyBaseUrl = `https://tyrell-proxy.${env}.rendered.ai`;

  try {
    await fetch(`${proxyBaseUrl}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch (err) {
    // Best-effort — don't block login/logout if the proxy is unreachable
    // eslint-disable-next-line no-console
    console.warn('[clearProxyAuth] Failed to clear proxy cookie:', err);
  }
};
